import {FC, ReactNode} from "react";
import {font} from "../style/typography.tsx";
import {Row} from "./Layout.tsx";

interface Props {
    for?: string;
    children: ReactNode;
}

const InputLabel: FC<Props> = ({for: htmlFor, children}) => {
    return (
        <Row>
            <label htmlFor={htmlFor} className={font("description", "2", "medium")}>
                {children}
            </label>
        </Row>
    );
}

export default InputLabel;